import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PassRewardTier } from '../types/pass'

import { api } from '@/shared/services/api'

// Resgate manual da recompensa de um tier do passe (igual às missões: o aluno
// clica para receber). Após o claim, invalida a lista para refletir o novo
// status (delivered) e as recompensas creditadas.
export function usePassClaimReward() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (tier: PassRewardTier) => {
      await api.post(`/user/pass_reward_tiers/${tier.id}/claim`)
      // O tier resgatado viaja junto com o resultado de propósito: a
      // invalidação abaixo faz o `highlightedTier` avançar para o próximo
      // marco, e a revelação mostraria a recompensa errada se fosse relê-lo
      // do passe depois do refetch.
      return tier
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/user/passes'] })
      queryClient.invalidateQueries({ queryKey: ['/user/gamification/progress'] })
    }
  })
}
